import React, { useState, useCallback } from "react";
import TopNav from "../layouts/TopNav";
import SingleSlipModal from "../components/SingleSlipModal";
import "../Styles/loading.css";
import { CircularProgress } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import ReLoginModal from "../components/ReLoginModal";
import { BiArrowBack } from "react-icons/bi";
import api from "../util/axios";

interface Payload {
  type: string;
  items: {
    _id: string;
    quantityToLoad: number;
    approvalNumber: string | undefined;
  }[];
  truckNumber: string;
  customer: string;
  licenseId?: string;
}

const LoadingSlip = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [reLogin, setReLogin] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [isLicenseModalOpen, setIsLicenseModalOpen] = useState(false);
  // const [licenseNumberInput, setLicenseNumberInput] = useState<string>('');

  const datas = location.state;
  // console.log("loading slip datas", datas);
  // console.log("check cus:", datas.customer);


  const [singleModal, setSingleModal] = useState(false);
  const handleSingle = () => {
    setSingleModal(!singleModal);
  };

  const token = window.localStorage.getItem("token");
  const [sign, setSign] = useState({
    requisitionApprovalNumbers: [""],
    supplyLocation: datas?.supplyLocation || "",
    truckNumber: datas?.truckNumber || "",
    type: "",
    quantityToLoad: "",
    quantity: datas?.requisitions?.[0]?.unitPrice || " ",
    customer: datas?.customer.businessName || "",
  });
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const handleSingleChanges = ({ target: { name, value } }: any) => {
    setSign((prevSign) => ({
      ...prevSign,
      [name]: value,
    }));
  };

  const [getApprovalDetails, setGetApprovalDetails] = useState({
    _id: "",
    truckNumber: "",
    // supplyLocation: "",
    items: [],
  });

  const proId = datas?.items?.map((user: { _id: any; }) => user._id) || [];
  const quantityToLoadInt = parseInt(sign.quantityToLoad, 10);

  const itemQuantity = datas?.items?.map((item: { volume: any; }) => item?.volume) || [];

  const availableQuantity = parseInt(itemQuantity[0], 10);

  const validateQuantity = (quantityToLoadInt: number, availableQuantity: number) => {
    if (quantityToLoadInt > availableQuantity) {
      Swal.fire({
        title: "Error!",
        text: "Amount to load cannot exceed the available quantity.",
        icon: "error",
        showCancelButton: false,
        confirmButtonColor: "red",
        confirmButtonText: "Try Again",
      });
      return false;
    }

    if (quantityToLoadInt === 0) {
      Swal.fire({
        title: "Error!",
        text: "Amount to load cannot be zero.",
        icon: "error",
        showCancelButton: false,
        confirmButtonColor: "red",
        confirmButtonText: "Try Again",
      });
      return false;
    }

    return true;
  };

  const handleSingleSubmit = (e: { preventDefault: () => void; }) => {
    e.preventDefault();

    if (!validateQuantity(quantityToLoadInt, availableQuantity)) {
      return;
    }
    setLoading(true);
    const payload: Payload = {
      type: "single",
      items: [
        {
          _id: proId[0] || "",
          quantityToLoad: load ? itemQuantity[0] : quantityToLoadInt,
          approvalNumber: datas?.approvalNumber
        },
      ],
      truckNumber: sign.truckNumber,
      customer: datas?.customer.businessName,
    };

    // console.log("Payload being sent:", payload);
    // console.log("pro id items:", datas.items)

    api
      .post("/loading-slip", payload, { headers: headers })
      .then((res) => {
        setLoading(false);
        Swal.fire({
          title: `Success!`,
          text: `${res.data.message}`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "green",
          confirmButtonText: "Continue",
        });
        // console.log("res::",res.data)
        navigate("/dashboard/slip", { state: { originalData: datas, newData: res.data.data } });
      })
      .catch((err) => {
        Swal.fire({
          title: `Error!`,
          text: `${err.response.data.message}`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "red",
          confirmButtonText: "Try Again",
        });
        if (err.response.data.message === "jwt expired" || err.response.data.message === "jwt malformed") {
           
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        setLoading(false);
      });
  };

  const [load, setLoad] = useState(false);

  const handleChange = () => {
    setLoad(!load);
    // console.log(load);
  };

  return (
    <div className="board">
      {reLogin ? <ReLoginModal /> : null}
      <TopNav title="Loading Slip" />

      <div className="loadingSlip">
        <span className="cursor-pointer mb-2 flex gap-2 items-center" onClick={(()=> navigate(-1))}><BiArrowBack/></span>
        <h2>Generate Loading Slip</h2>
        <p>Slip based on Single Approval</p>
        <div className="generateSlip flex">
          <form onSubmit={handleSingleSubmit} className="singleSlip">
            <div className="input lsInput">
              <label>Amount to load(Available Quantity: {availableQuantity}) </label>
              <input
                type="number"
                name="quantityToLoad"
                value={load ? itemQuantity[0] || "" : sign.quantityToLoad}
                onChange={handleSingleChanges}
              />
            </div>
            <div style={{ fontSize: "16px", marginBottom: "1em" }}>
              <input type="checkbox" onChange={handleChange} />
              <span>Click to load all quantity</span>
            </div>
            <div className="slipBr">
            </div>
            <div className="slipBr">
              <div className="input lsInput">
                <label>Truck Number</label>
                <input
                  type="text"
                  name="truckNumber"
                  value={sign.truckNumber}
                  onChange={handleSingleChanges}
                />
              </div>
            </div>
            <div className="input lsInput">
              <label>Customer Name</label>
              <input
                type="text"
                name="customer"
                value={datas?.customer.businessName}
                onChange={handleSingleChanges}
              />
            </div>
            <div className="input lsInput">
              <label>Approval Number</label>
              <input type="text" value={datas?._id || ""} readOnly />
            </div>
            <button type="submit" className="catBtn1">
              {loading ? (
                <CircularProgress
                  style={{
                    color: "#fff",
                    backgroundColor: "transparent",
                    width: "20px",
                    height: "20px",
                  }}
                />
              ) : (
                "Generate Slip"
              )}
            </button>
          </form>
        </div>
      </div>
      {singleModal ? (
        <SingleSlipModal
          handleSingle={handleSingle}
          setGetApprovalDetails={setGetApprovalDetails}
        />
      ) : null}
    </div>
  );
};

export default LoadingSlip;
